"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InquiryOrderFormApi = void 0;
const runtime = __importStar(require("../runtime"));
const index_1 = require("../models/index");
/**
 *
 */
class InquiryOrderFormApi extends runtime.BaseAPI {
    /**
     * 推進訂單狀態到下一個階段  A1(已送出訂單) → A2(訂單處理中) → B1(已出貨) → B2(已完成)
     */
    inquiryOrderFormAdvanceOrderStatus2PatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['formNo'] != null) {
                queryParameters['formNo'] = requestParameters['formNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/AdvanceOrderStatus2`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 推進訂單狀態到下一個階段  A1(已送出訂單) → A2(訂單處理中) → B1(已出貨) → B2(已完成)
     */
    inquiryOrderFormAdvanceOrderStatus2Patch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormAdvanceOrderStatus2PatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 推進訂單狀態到下一個階段  A1(已送出訂單) → A2(訂單處理中) → B1(已出貨) → B2(已完成)
     */
    inquiryOrderFormAdvanceOrderStatusPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['formNo'] != null) {
                queryParameters['formNo'] = requestParameters['formNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/AdvanceOrderStatus`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 推進訂單狀態到下一個階段  A1(已送出訂單) → A2(訂單處理中) → B1(已出貨) → B2(已完成)
     */
    inquiryOrderFormAdvanceOrderStatusPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormAdvanceOrderStatusPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 後台取消訂單（管理員操作）
     */
    inquiryOrderFormCancelOrderPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['formNo'] != null) {
                queryParameters['formNo'] = requestParameters['formNo'];
            }
            if (requestParameters['cancelMemo'] != null) {
                queryParameters['cancelMemo'] = requestParameters['cancelMemo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/CancelOrder`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 後台取消訂單（管理員操作）
     */
    inquiryOrderFormCancelOrderPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormCancelOrderPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-新增
     */
    inquiryOrderFormCreatePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/Create`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.InquiryOrderFormEditViewModelToJSON)(requestParameters['inquiryOrderFormEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-新增
     */
    inquiryOrderFormCreatePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormCreatePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-刪除
     */
    inquiryOrderFormDeleteDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/Delete`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-刪除
     */
    inquiryOrderFormDeleteDelete() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormDeleteDeleteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 下載發票檔案
     */
    inquiryOrderFormDownloadInvoiceGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['formNo'] != null) {
                queryParameters['formNo'] = requestParameters['formNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/DownloadInvoice`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * 下載發票檔案
     */
    inquiryOrderFormDownloadInvoiceGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormDownloadInvoiceGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-編輯
     */
    inquiryOrderFormEditPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/Edit`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.InquiryOrderFormEditViewModelToJSON)(requestParameters['inquiryOrderFormEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-編輯
     */
    inquiryOrderFormEditPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormEditPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-匯出
     */
    inquiryOrderFormExportGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['name'] != null) {
                queryParameters['Name'] = requestParameters['name'];
            }
            if (requestParameters['cell'] != null) {
                queryParameters['Cell'] = requestParameters['cell'];
            }
            if (requestParameters['useStatus'] != null) {
                queryParameters['UseStatus'] = requestParameters['useStatus'];
            }
            if (requestParameters['fromId'] != null) {
                queryParameters['FromId'] = requestParameters['fromId'];
            }
            if (requestParameters['payStatus'] != null) {
                queryParameters['PayStatus'] = requestParameters['payStatus'];
            }
            if (requestParameters['orderString'] != null) {
                queryParameters['orderString'] = requestParameters['orderString'];
            }
            if (requestParameters['currentPage'] != null) {
                queryParameters['currentPage'] = requestParameters['currentPage'];
            }
            if (requestParameters['pageSize'] != null) {
                queryParameters['pageSize'] = requestParameters['pageSize'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/Export`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * 詢價單查詢和匯出-匯出
     */
    inquiryOrderFormExportGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormExportGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    inquiryOrderFormGetBaseInformationGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetBaseInformation`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     */
    inquiryOrderFormGetBaseInformationGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.inquiryOrderFormGetBaseInformationGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-編輯頁查詢
     */
    inquiryOrderFormGetByIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetById`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-編輯頁查詢
     */
    inquiryOrderFormGetByIdGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetByIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 包裝方式/取貨方式
     */
    inquiryOrderFormGetCodeListByOrderGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['type'] != null) {
                queryParameters['type'] = requestParameters['type'];
            }
            if (requestParameters['no'] != null) {
                queryParameters['No'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetCodeListByOrder`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 包裝方式/取貨方式
     */
    inquiryOrderFormGetCodeListByOrderGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetCodeListByOrderGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-顏色關鍵字下拉選單
     */
    inquiryOrderFormGetColorListGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['key'] != null) {
                queryParameters['key'] = requestParameters['key'];
            }
            if (requestParameters['no'] != null) {
                queryParameters['No'] = requestParameters['no'];
            }
            if (requestParameters['spec'] != null) {
                queryParameters['spec'] = requestParameters['spec'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetColorList`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-顏色關鍵字下拉選單
     */
    inquiryOrderFormGetColorListGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetColorListGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-優惠券列表查詢
     */
    inquiryOrderFormGetCouponsPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetCoupons`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.InquiryOrderCouponSearchModelToJSON)(requestParameters['inquiryOrderCouponSearchModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-優惠券列表查詢
     */
    inquiryOrderFormGetCouponsPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetCouponsPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-明細列表查詢
     */
    inquiryOrderFormGetDetailPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetDetail`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.InquiryOrderDetailSearchModelToJSON)(requestParameters['inquiryOrderDetailSearchModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-明細列表查詢
     */
    inquiryOrderFormGetDetailPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetDetailPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得發票資訊
     */
    inquiryOrderFormGetInvoiceGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['formNo'] != null) {
                queryParameters['formNo'] = requestParameters['formNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetInvoice`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得發票資訊
     */
    inquiryOrderFormGetInvoiceGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetInvoiceGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-複選選項
     */
    inquiryOrderFormGetItemGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['type'] != null) {
                queryParameters['type'] = requestParameters['type'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetItem`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-複選選項
     */
    inquiryOrderFormGetItemGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetItemGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 取得訂單狀態清單（從 CodeSettings 動態讀取）
     */
    inquiryOrderFormGetOrderStatusesGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetOrderStatuses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 取得訂單狀態清單（從 CodeSettings 動態讀取）
     */
    inquiryOrderFormGetOrderStatusesGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.inquiryOrderFormGetOrderStatusesGetRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-分頁查詢
     */
    inquiryOrderFormGetPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/Get`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.InquiryOrderFormSearchModelToJSON)(requestParameters['inquiryOrderFormSearchModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-分頁查詢
     */
    inquiryOrderFormGetPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-商品列表查詢
     */
    inquiryOrderFormGetProductPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetProduct`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.InquiryOrderProductSearchModelToJSON)(requestParameters['inquiryOrderProductSearchModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-商品列表查詢
     */
    inquiryOrderFormGetProductPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetProductPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-明細資料
     */
    inquiryOrderFormGetSelectedItemsGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['formNo'] != null) {
                queryParameters['formNo'] = requestParameters['formNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/GetSelectedItems`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-明細資料
     */
    inquiryOrderFormGetSelectedItemsGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormGetSelectedItemsGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-商品編輯
     */
    inquiryOrderFormProductEditPatchRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/ProductEdit`,
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.InquiryOrderProductEditViewModelToJSON)(requestParameters['inquiryOrderProductEditViewModel']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-商品編輯
     */
    inquiryOrderFormProductEditPatch() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormProductEditPatchRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 詢價單查詢和匯出-商品資料
     */
    inquiryOrderFormProductGetByIdGetRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['no'] != null) {
                queryParameters['no'] = requestParameters['no'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/ProductGetById`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 詢價單查詢和匯出-商品資料
     */
    inquiryOrderFormProductGetByIdGet() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormProductGetByIdGetRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 將詢價單轉入織品雲管理平台訂單
     */
    inquiryOrderFormTransferToOrderPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['formNo'] != null) {
                queryParameters['formNo'] = requestParameters['formNo'];
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/TransferToOrder`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 將詢價單轉入織品雲管理平台訂單
     */
    inquiryOrderFormTransferToOrderPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormTransferToOrderPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * 上傳發票（一筆訂單一個發票，重複上傳覆蓋）
     */
    inquiryOrderFormUploadInvoicePostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["Authorization"] = yield this.configuration.apiKey("Authorization"); // Bearer authentication
            }
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime.canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters['formNo'] != null) {
                formParams.append('formNo', requestParameters['formNo']);
            }
            if (requestParameters['file'] != null) {
                formParams.append('file', requestParameters['file']);
            }
            const response = yield this.request({
                path: `/InquiryOrderForm/UploadInvoice`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.ResponseModelFromJSON)(jsonValue));
        });
    }
    /**
     * 上傳發票（一筆訂單一個發票，重複上傳覆蓋）
     */
    inquiryOrderFormUploadInvoicePost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.inquiryOrderFormUploadInvoicePostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.InquiryOrderFormApi = InquiryOrderFormApi;
